/* KNK UI behaviours: lightbox, pattern filter, inquiry prefill,
   hero video loading, contact tracking and the WhatsApp button.
   Config comes from window.KNK (set in layout/theme.liquid). */
(function () {
  'use strict';

  var KNK = window.KNK || {};

  function track(name, params) {
    if (typeof window.gtag !== 'function') return;
    try { window.gtag('event', name, params || {}); } catch (e) { /* no-op */ }
  }

  /* ---------- Lightbox (gallery + pattern library) ---------- */
  var dialog;
  var group = [];
  var index = 0;

  function buildDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'knkx kx-lightbox';
    dialog.setAttribute('aria-label', 'Image viewer');
    dialog.innerHTML =
      '<button type="button" class="kx-lightbox__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="kx-lightbox__nav kx-lightbox__nav--prev" aria-label="Previous image">&#8249;</button>' +
      '<img alt="">' +
      '<button type="button" class="kx-lightbox__nav kx-lightbox__nav--next" aria-label="Next image">&#8250;</button>' +
      '<p class="kx-lightbox__caption"></p>';
    document.body.appendChild(dialog);
    dialog.querySelector('.kx-lightbox__close').addEventListener('click', function () { dialog.close(); });
    dialog.querySelector('.kx-lightbox__nav--prev').addEventListener('click', function () { show(index - 1); });
    dialog.querySelector('.kx-lightbox__nav--next').addEventListener('click', function () { show(index + 1); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
    return dialog;
  }

  function show(i) {
    if (!group.length) return;
    index = (i + group.length) % group.length;
    var btn = group[index];
    var img = dialog.querySelector('img');
    img.src = btn.getAttribute('data-full');
    img.alt = btn.getAttribute('data-alt') || '';
    var cap = btn.getAttribute('data-caption') || '';
    var capEl = dialog.querySelector('.kx-lightbox__caption');
    capEl.textContent = cap;
    capEl.hidden = !cap;
    var multi = group.length > 1;
    dialog.querySelector('.kx-lightbox__nav--prev').hidden = !multi;
    dialog.querySelector('.kx-lightbox__nav--next').hidden = !multi;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kx-lightbox]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('[data-kx-lightbox-group]') || document;
    group = Array.prototype.filter.call(scope.querySelectorAll('[data-kx-lightbox]'), function (b) {
      return !b.closest('[hidden]');
    });
    buildDialog();
    show(group.indexOf(btn));
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else window.open(btn.getAttribute('data-full'), '_blank');
  });

  /* ---------- Pattern filter ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kx-filter]');
    if (!b) return;
    var root = b.closest('[data-kx-filter-root]');
    if (!root) return;
    var value = b.getAttribute('data-kx-filter');
    root.querySelectorAll('[data-kx-filter]').forEach(function (x) {
      x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
    });
    root.querySelectorAll('[data-kx-type]').forEach(function (item) {
      item.hidden = value !== 'all' && item.getAttribute('data-kx-type') !== value;
    });
  });

  /* ---------- Inquiry prefill: buttons with data-kx-machine ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-kx-machine]');
    if (!a) return;
    var machine = a.getAttribute('data-kx-machine');
    var select = document.querySelector('#inquiry select[data-kx-machine-select]');
    if (select && machine) {
      var match = Array.prototype.find.call(select.options, function (o) { return o.value === machine; });
      if (match) select.value = machine;
    }
    var topic = a.getAttribute('data-kx-topic');
    var msg = document.querySelector('#inquiry textarea');
    if (msg && topic && !msg.value) msg.value = topic;
  });

  /* ---------- Hero background video: load only when it makes sense ---------- */
  function loadHeroVideos() {
    var conn = navigator.connection || {};
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var slow = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
    document.querySelectorAll('video[data-kx-autoload]').forEach(function (v) {
      if (reduce || slow) return;
      var src = v.getAttribute('data-src');
      if (!src) return;
      v.src = src;
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* poster stays */ });
    });
  }
  if (document.readyState === 'complete') loadHeroVideos();
  else window.addEventListener('load', loadHeroVideos);

  /* Machine videos: fire an event the first time each one plays */
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!(v instanceof HTMLVideoElement) || v.hasAttribute('data-kx-autoload') || v.dataset.kxTracked) return;
    v.dataset.kxTracked = '1';
    track('video_start', { video_title: v.getAttribute('title') || document.title });
  }, true);

  /* ---------- Contact click tracking ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    var method = null;
    if (/wa\.me|whatsapp\.com/i.test(href)) method = 'whatsapp';
    else if (/^mailto:/i.test(href)) method = 'email';
    else if (/^tel:/i.test(href)) method = 'phone';
    if (!method) return;
    track('contact_click', { method: method, page_path: location.pathname });
    if (KNK.adsContact) track('conversion', { send_to: KNK.adsContact });
  });

  /* ---------- WhatsApp float: reuse an existing one, else add ours ---------- */
  function waHref() {
    var text = KNK.waText || 'Hello KNK, I would like to discuss a machine project.';
    return 'https://wa.me/' + (KNK.waNumber || '') + '?text=' + encodeURIComponent(text);
  }
  function adoptLegacy() {
    var legacy = document.querySelector('a.knk-wa-float');
    if (!legacy) return false;
    legacy.href = waHref();
    var ours = document.querySelector('.kx-wa-float');
    if (ours) ours.remove();
    return true;
  }
  function setupWhatsApp() {
    if (!KNK.waNumber) return;
    if (adoptLegacy()) return;
    if (document.querySelector('.kx-wa-float')) return;
    var a = document.createElement('a');
    a.className = 'kx-wa-float';
    a.href = waHref();
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Chat with KNK on WhatsApp');
    a.innerHTML = '<svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true"><path d="M16.04 3C8.86 3 3.04 8.8 3.04 15.96c0 2.3.6 4.52 1.74 6.48L3 29l6.73-1.76a13 13 0 0 0 6.3 1.6h.01c7.17 0 13-5.8 13-12.97C29.04 8.8 23.2 3 16.04 3Zm0 23.66h-.01a10.8 10.8 0 0 1-5.5-1.5l-.4-.23-4 1.04 1.07-3.88-.26-.4a10.7 10.7 0 0 1-1.66-5.73c0-5.95 4.86-10.8 10.83-10.8 5.96 0 10.8 4.85 10.8 10.8 0 5.96-4.85 10.8-10.87 10.8Zm5.93-8.08c-.32-.16-1.92-.95-2.22-1.05-.3-.11-.51-.16-.73.16-.22.32-.84 1.05-1.03 1.27-.19.21-.38.24-.7.08-.33-.16-1.38-.5-2.62-1.6-.97-.86-1.62-1.92-1.81-2.25-.19-.32-.02-.5.14-.66.15-.14.33-.38.49-.57.16-.19.21-.32.32-.54.11-.21.05-.4-.03-.56-.08-.16-.73-1.75-1-2.4-.26-.63-.53-.54-.73-.55h-.62c-.21 0-.56.08-.86.4-.3.32-1.13 1.1-1.13 2.68 0 1.58 1.16 3.11 1.32 3.33.16.21 2.28 3.47 5.52 4.87.77.33 1.37.53 1.84.68.77.24 1.48.21 2.03.13.62-.1 1.92-.79 2.19-1.54.27-.75.27-1.4.19-1.54-.08-.13-.3-.21-.62-.37Z"/></svg>';
    document.body.appendChild(a);
  }
  // An older float (a.knk-wa-float) is injected late by an external script.
  // Watch for it for a while: if it appears, rewrite its message and drop ours.
  if (KNK.waNumber && 'MutationObserver' in window) {
    var mo = new MutationObserver(function () { if (adoptLegacy()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
  window.addEventListener('load', function () {
    adoptLegacy();
    setTimeout(setupWhatsApp, 3000);
  });
})();
